<!-- MODAL - 6 : FILE INFO Modal - MOBILE ONLY -->
@if ((universalService.selectedTab == 'Albums' || universalService.selectedTab == 'Album Details') && universalService.isMobileDevice) {
  <div [ngStyle]="{'display': showFileInfo && universalService.isMobileDevice ? 'block' : 'none', 'opacity': 1}" class="modal fade mobFileInfoPanel"
    id="m-file-info-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <!--data-backdrop="static"-->
    <div class="modal-dialog" role="document">
      <div class="modal-content animated slideOutUp fixed-bottom">
        @if (!universalService.isMobileFilePreviewOpen && universalService?.selectedFile?.objectType != 'FR' && (universalService?.selectedFile?.format == 'audio' || universalService?.selectedFile?.format == 'video' || universalService?.selectedFile?.format == 'image')) {
          <div class="mobIfoHeader modal-header pt-0 pb-0">
            <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)='closeMobileFileInfo()'>
              <span class="Neueclosefilled"></span><span class="esc">esc</span>
            </button>
            @if (showFileInfo && fileInfoUrl) {
              <div class="mobThumbnailCont" [ngStyle]="{'background-size':'100%'}">
                @if (this.universalService?.selectedFile?.format == 'image' || this.universalService?.selectedFile?.format == 'audio' || this.universalService?.selectedFile?.format == 'video' ) {
                  <img src="{{fileInfoUrl}}" (error)="universalService.thumbnailError($event)" class="img-fluid top-rounded objectImage img-fluid blur__content"
                    />
                }
                <img src="{{fileInfoUrl}}" class='no_blur__content' (error)="universalService.thumbnailError($event)" />
              </div>
            }
            <div class="defaultIconCont">
              <span class="{{defaultContent?.className}}"></span>
            </div>
          </div>
        }
        <div class="modal-body pt-0">
          <!---------------------------------------------------------------------------------------------------------------------------------->
          <div class="img-info-details pl-2 pr-2 file-name-container" [class.defaultFolderThumbnailCont]="this.universalService?.selectedFile?.objectType == 'FR'">
            @if (universalService?.selectedFile?.objectType != 'FR') {
              <div class="mini-thumb-details mini-thumb-details-folder  mb-3">
                @if (universalService?.selectedFile?.objectType == 'FE' || universalService?.selectedFile?.objectType == 'BE' ||
                  universalService?.selectedFile?.objectType == 'DE' || universalService?.selectedFile?.objectType == 'BB'
                  || universalService?.selectedFile?.objectType == 'SE' ) {
                  <span class="float-left pt-3 selectedObjName">{{this.universalService?.selectedFile?.objectName}}</span>
                }
                @if (universalService.showPreview == true || universalService?.selectedFile?.format=='Presentation' || universalService?.selectedFile?.format=='text'||universalService?.selectedFile?.format=='SpreadSheet'||universalService?.selectedFile?.format=='PDF' || universalService?.selectedFile?.format=='Document' || universalService?.selectedFile?.format=='MSOfficeDocument') {
                  <button type="button" tabindex="-1" class="close btn-pos doc-info-close" data-dismiss="modal" (click)='this.closeMobileFileInfo()'>
                    <span class="NeueFile_Cancel"></span><span class="esc">esc</span>
                  </button>
                }
                @if (universalService?.selectedFile?.format!='video'&& universalService?.selectedFile?.format!='image'  && universalService?.selectedFile?.format!='audio' && universalService?.selectedFile?.format!='Presentation' && universalService?.selectedFile?.format!='text' && universalService?.selectedFile?.format!='SpreadSheet' && universalService?.selectedFile?.format!='PDF' && universalService?.selectedFile?.format!='Document' && universalService?.selectedFile?.format!='MSOfficeDocument') {
                  <button type="button" tabindex="-1" class="close btn-pos doc-info-close" data-dismiss="modal" (click)='this.closeMobileFileInfo()'>
                    <span class="NeueFile_Cancel"></span><span class="esc">esc</span>
                  </button>
                }
                <!-- Need this cancel icon in case of documents only
                && object.format != 'image'  && object.format != 'audio' && object.format != 'video'-->
              </div>
            }
            @if (this.universalService?.selectedFile?.objectType == 'FR') {
              <div class="mini-thumb-details mb-3  fld defaultFolderThumbnailCont">
                <button type="button" tabindex="-1" class="close btn-pos" data-dismiss="modal" (click)='this.closeMobileFileInfo()'>
                  <span class="NeueFile_Cancel"></span><span class="esc">esc</span>
                </button>
                <div class="defaultFolderThumbnail">
                  <span class="NeueFolderFilled"></span>
                </div>
                <span class="float-left pt-3 fld selectedObjName">{{this.universalService?.selectedFile?.objectName}}</span>
              </div>
            }
            <ul class="mt-3">
              @for (item of infoItems; track item) {
                <li>
                  <h6>{{item.title}}</h6>
                  <span>{{item.value}}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
}


<!-- MODAL - 6 : FILE INFO Modal - DESKTOP/Mobile for Repo ONLY -->
<div class="file-info-panel-main sidenav modal-popup" id="mySidenav" [ngStyle]="{'display': showFileInfo ? 'block' : 'none', 'opacity': 1}">
  <header id="desk-info-header">
    <div data-brackets-id="18679" class="mini-thumb-details border-0 pb-0">
      @if(this.universalService.selectedFile?.isBackupDevices != 'Y'){
        <span data-brackets-id="18682" class="infoHeader float-left pl-2">{{this.universalService?.selectedFile?.objectType =='FR' || this.universalService?.selectedFile?.objectType == 'BR' ? 'Folder': 'File'}} Info</span>
      }@else{
        <span data-brackets-id="18682" class="infoHeader float-left pl-2">Backup Device Info</span>
      }
      <!-- Close Icon -->
      <div class="float-right" title="Close Panel" (click)="closeNav()">
        @if (!universalService.isMobileDevice) {
          <span class="escapeText">esc</span>
        }
        <span class="Neueclosefilled pl-1 float-right cursor-pointer" style="color: var(--themeColor);"></span>
      </div>
    </div>
  </header>
  <section>
    <div class="img-wrapper" id="desk-info-img-wrapper">
      @if ((this.universalService?.selectedFile?.mimeType == 'image'|| this.universalService?.selectedFile?.mimeType == 'video' || this.universalService?.selectedFile?.mimeType == 'audio') && fileInfoUrl) {
        <div class="imgThumbnailCont backGroundColor" [ngStyle]="{'background-size':'100%'}" >
          <img src="{{this.fileInfoUrl}}" class='img-fluid blur__content' (error)="this.handleBgColor($event);this.universalService.thumbnailError($event)" />
          <img src="{{this.fileInfoUrl}}" class='no_blur__content' (error)="this.handleBgColor($event);this.universalService.thumbnailError($event)" />
        </div>
      }
      @if (universalService.selectedFile?.format == 'Document' || universalService.selectedFile?.format == 'SpreadSheet' || universalService.selectedFile?.format == 'Presentation' || universalService.selectedFile?.format == 'MSOfficeDocument') {
        <div class="ms-document-tile">
          <img src="{{universalService.selectedFile?.MSOfficeImage}}" class='no_blur__content'/>
        </div>
      }
      <div class="defaultIconCont">
        <span class="{{defaultContent?.className}} rounded-0 side-info-panel-addons"></span>
      </div>

    </div>

    <!-- Details/Activity/Comments -->
    <div class="file-info-tabs-wrapper">
      <div class="file-info-tabs-main" id="file-info-tabs-main">
        @if (this.universalService.currentTab != 'PrivateFolder' && universalService.selectedTab != 'Albums' && universalService.selectedTab != 'Album Details') {
          <nav aria-labelledby="file-info-tabs-main" class="slidemenu-file-info">
            <fieldset aria-label="fileinfo">
              <!-- Menú Item 1 -->
              <input type="radio" name="slideItem" id="fileinfo-item-1" class="slide-toggle-opaque" checked="" />
              <label for="fileinfo-item-1" (click)="navigateFileInfoTabs('Details')">
                <div class="m-alignment d-inline-block" >
                  Details
                </div>
              </label>
              <!-- Menú Item 2 -->
              <input type="radio" name="slideItem" id="fileinfo-item-2" class="slide-toggle-opaque" />
              <label for="fileinfo-item-2" (click)="navigateFileInfoTabs('Activity')" [ngClass]="[this.router.url.includes('/teamfolder') || universalService.selectedFile?.tfKey || !this.universalService?.selectedFile?.shareKey || universalService?.selectedFile?.previewFromUpload ? 'div-disabled' : '']">
                <div class="m-alignment d-inline-block">
                  Activity
                </div>
              </label>
              <!-- Menú Item 3 -->
              <input type="radio" name="slideItem" id="fileinfo-item-3" class="slide-toggle-opaque" />
              @if (!this.router.url.includes('/teamfolder') && !universalService.selectedFile?.tfKey) {
                <label for="fileinfo-item-3" (click)="navigateFileInfoTabs('Comments')" [ngClass]="[!this.universalService?.selectedFile?.shareKey || universalService?.selectedFile?.previewFromUpload ? 'div-disabled' : '']">
                  <div class="m-alignment d-inline-block" >
                    Comments
                  </div>
                </label>
              }
              @if (!universalService?.selectedFile?.previewFromUpload && (this.router.url.includes('/teamfolder') || universalService.selectedFile?.tfKey)) {
                <label for="fileinfo-item-3" (click)="navigateFileInfoTabs('Comments')" >
                  <div class="m-alignment d-inline-block" >
                    Comments
                  </div>
                </label>
              }
              <!-- Bar of the bottom -->
              <div class="file-info-slider">
                <div class="bar d-lg-block"></div>
              </div>
            </fieldset>
          </nav>
        }
        <!-- Tab Contents -->
        <div class="file-info-scrollable" tabindex="0">
          <!-- DETAILS TAB CONTENT Starts -->
          <div class="details-tab-content" [ngStyle]="{'display': universalService.showInfoDetails ? 'block' : 'none', 'opacity': 1}">
            <div class="img-info-details">
              <ul>
                @if(this.universalService.selectedFile?.isBackupDevices != 'Y'){
                  <li>
                    <h6>Name:</h6>
                    <form [formGroup]="fileRename">
                      <div class='file-name-container'>
                        <div class="file-name-wrapper" [hidden]="this.universalService?.selectedFile?.editName">
                          <p class="file-info-name">
                            <span>{{this.universalService?.selectedFile?.objectName}}</span>
                            @if (this.universalService.activeRepo == 'main' && canUserEditName == true && !universalService?.selectedFile?.previewFromUpload) {
                              <span class="NeueEdit" (click)="editFileName()"></span>
                            }

                          </p>

                        </div>
                        <div class="file-name-edit" [hidden]="!this.universalService?.selectedFile?.editName">
                          <div class="rename-file-inputs mr-2">
                            <input type='text' (keypress)="keyPressCount($event)" class='rename-file-box inputRename' id='file_info_rename' maxLength='200' name="daysPeriod" name="fileName" formControlName="fileName" aria-label="file-name" [ngClass]="[ universalService?.selectedFile?.objectType == 'FR' ? 'rename-folder-box' : '']"/>
                            <input type='text' formControlName="fileExtn" readonly class='file-extension' aria-label="file-extension" [ngClass]="[ universalService?.selectedFile?.objectType == 'FR' ? 'folderCheck' : '']" />
                          </div>
                          <div class="btn fileInfoBtn">
                            <span class="NeueCheck infoRenameAnchor" (click)="renameFile()"></span>
                          </div>

                        </div>
                        <div style="clear: both;"></div>
                        @if (renameError) {
                          <p class='errorBlock file-rename-Error'>
                            <i class="NeueAlert mr-1"></i>{{renameError}}
                          </p>
                        }
                      </div>
                    </form>
                  </li>
                }
                @for (item of infoItems; track item) {
                  <li class="pb-1">
                    <h6>{{item.title}}</h6>
                    <span>{{item.value}}</span>
                  </li>
                }
              @if ( !this.publicLinknotLoggedIn && universalService?.selectedFile?.shareKey) {
                <li class="pb-1">
                  <!-- <span class="txt-show-all">Show All</span> -->
                  <h6>Shared with</h6>
                  <!-- <span>Thursday, June 03 2020, 13:40</span> -->
                  @if (shareObjectsImplementation.sharedWithNamesLink != 'Not Shared yet') {
                    <a href="javascript:void(0);" rel="noopener noreferrer" class="go-to-manage-access" (click)="openManageAccessView()">
                      <span>{{shareObjectsImplementation.sharedWithNamesLink}}</span> <span style="padding-left: 4px;">{{shareObjectsImplementation.sharedWithMoreCountText}}</span>
                    </a>
                  }
                  @if (shareObjectsImplementation.sharedWithNamesLink == 'Not Shared yet') {
                    <span class="go-to-manage-access">
                      Not Shared yet
                    </span>
                  }
                </li>
              }
            </ul>

          </div>
        </div>
        <!-- DETAILS TAB CONTENT Ends -->
        @if (universalService.showInfoActivity) {
          <lib-file-info-activity/>
        }
        @if (universalService.showInfoComments) {
          <lib-file-info-comments/>
        }
      </div>
    </div>
  </div>
</section>
<div class="spinner_loader">
  <div class="small_loader"></div>
</div>
</div>
<!-- FILE INFO PANEL ENDS --->